import RouterConfig from "navigations/RouterConfig";
import React from "react";

const App = () => <RouterConfig />;

export default App;
